import React from 'react';
import { SwapOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { updateVendorStatus } from '../../../../services/parametersService';
import ButtonOperation from 'components/ButtonOperation';

export type ActivateDisableVendorButtonProps = ButtonProps & {
  mgid: number;
  vendorid: number;
  statusToUpdate: string;
  refetch: () => void;
};

const ActivateDisableVendorButton: React.FC<
  ActivateDisableVendorButtonProps
> = ({ size = 'small', refetch, statusToUpdate, mgid, vendorid, ...props }) => {
  const status = statusToUpdate === 'ENABLED' ? 'DISABLED' : 'ENABLED';
  return (
    // <Button
    //   style={{
    //     height:35
    //   }}
    //   onClick={() => {
    //     updateVendorStatus({
    //       mgid,
    //       vendorid,
    //       status,
    //     }).then(() => {
    //       notification.success({ message: 'Vendor updated' });
    //       refetch();
    //     });
    //   }}
    //   {...props}
    // >
    //   {statusToUpdate === }
    // </Button>
    <ButtonOperation
      htmlType="button"
      onClick={() => {
        updateVendorStatus({
          mgid,
          vendorid,
          status,
        }).then(() => {
          notification.success({ message: 'Vendor updated' });
          refetch();
        });
      }}
      icon={<SwapOutlined />}
      {...props}
      comcode={statusToUpdate === 'ENABLED' ? 'Disable' : 'ENABLED'}
    />
  );
};

export default ActivateDisableVendorButton;
